import React from 'react'
import classNames from 'classnames'

import classes from '../styles/list.module.sass'

export const BulletList = ({ className, children }) => (
    <ul className={classNames(classes.bulletList, className)}>{children}</ul>
)

export const ListItem = ({ children, ...props }) => (
    <li {...props}>
        <p>{children}</p>
    </li>
)

export const NumberedList = ({ className, children }) => (
    <ol className={classNames(classes.numberedList, className)}>{children}</ol>
)
